import { Survey, SurveyType } from '../../../../../../types/working-model';
import Checkbox from '../../../../../general-ui/checkbox/checkbox';
import Icon, { COLORS, ICONS } from '../../../../../general-ui/icon';

interface Props {
	isSelected: boolean;
	onChange: (shouldRemove: boolean, survey: Survey) => void;
	onEditClick: (survey: Survey) => void;
	onDeleteClick: (survey: Survey) => void;
	style: React.CSSProperties;
	survey: Survey;
}

export default function SurveySelectItem({ isSelected, onChange, onEditClick, onDeleteClick, style, survey }: Props): JSX.Element | null {
	return (
		<div
			className='survey-row-container'
			style={style}
		>
			<div className={`survey-row ${isSelected ? 'selected' : ''}`}>
				<div className="checkbox-and-data-container">
					<div className="checkbox-container">
						<Checkbox
							onChange={() => onChange(isSelected, survey)}
							checked={isSelected}
							value={survey.survey}
							color={'white'}
							activeColor={'cyan'}
						/>
					</div>
					<div className="survey-data">
						<div className="survey-question-type">{survey.survey_type === SurveyType.quiz ? 'QUIZ' : 'SURVEY'}</div>
						<div className="survey-question-title">{survey.name.base.length > 100 ? survey.name.base.substr(0, 100 - 3) + '...' : survey.name.base}</div>
						<div className="question-count">{`${survey
							.questions?.length ?? '0'} question${survey.questions?.length === 1 ? '' : 's'
							}`}</div>
					</div>
				</div>
				<div className="survey-actions">
					<button
						className="survey-question-actions-button button-margin-right"
						onClick={() => onEditClick(survey)}
					>
						<Icon
							name={ICONS.EDIT}
							size={10}
							color={COLORS.MED_LIGHT_GRAY}
						/>
					</button>
					{/* COMMENTING OUT BECAUSE WE DONE HAVE THE onDeleteClick BUILT OUT */}
					{/* <button
						className="survey-question-actions-button"
						onClick={() => onDeleteClick(survey)}
					>
						<Icon
							name={ICONS.TRASH}
							size={10}
							color={COLORS.MED_LIGHT_GRAY}
						/>
					</button> */}
				</div>
			</div>
		</div>
	);
}